import './unique_actions.scss';

import { SettingsContext } from 'context/context';
import { useContext } from 'react';

function UniqueActions({actions}) {
  const { state } = useContext(SettingsContext);

  const filterActions = (actions) => {
    let filteredActions = actions;
    if (!state.displayEquipment) {
      filteredActions = filteredActions.filter((action) => !action.addon);
    }

    return filteredActions.map((action, index) => {
      if (action !== '-') {
        return (
          <p key={index}>
            <b dangerouslySetInnerHTML={{__html: action.name}}/>
            { state.succinctActions ? '' : ': '}
            { state.succinctActions ? null : <span dangerouslySetInnerHTML={{__html: action.description}}/> }
          </p>
        );
      } else {
        return (<p key={index}>-</p>);
      }
    });
  }

  return (
    <div className="actions">
      <h4>Unique Actions</h4>
      { filterActions(actions) }
    </div>
  );
}

export default UniqueActions;
